import ModalStratto from "./ModalStratto";

export default ModalStratto;